import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Mail, MapPin, Clock, MessageCircle, ExternalLink, HelpCircle, Headphones, Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";
const Contact = () => {
  const navigate = useNavigate();
  const handleGetSupport = () => {
    navigate('/support');
  };
  return <section id="contact" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-background to-secondary/10">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center space-y-4 mb-16">
          <Badge variant="secondary" className="text-sm font-medium">
            Get In Touch
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold">
            Ready to Get
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              {" "}Started?
            </span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Have questions about CareKonnect? Need support? 
            Our comprehensive support system is here to help you.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Support Options */}
          <div className="space-y-6">
            <Card className="shadow-lg hover:shadow-xl transition-shadow" style={{
            boxShadow: 'var(--shadow-elegant)'
          }}>
              <CardHeader className="text-center">
                <HelpCircle className="w-12 h-12 text-primary mx-auto mb-4" />
                <CardTitle className="text-2xl">Get Support & Answers</CardTitle>
                <CardDescription>
                  Access our comprehensive help center with FAQs, support tickets, and direct contact options.
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <Button onClick={handleGetSupport} className="w-full bg-gradient-to-r from-primary to-primary-glow hover:shadow-lg text-lg h-12">
                  <Headphones className="w-5 h-5 mr-2" />
                  Visit Support Center
                  <ExternalLink className="w-4 h-4 ml-2" />
                </Button>
                
                <div className="grid grid-cols-1 gap-3">
                  <div className="text-center p-3 bg-secondary/10 rounded-lg">
                    <div className="text-sm font-medium">Support Hours</div>
                    <div className="text-xs text-muted-foreground">8AM - 6PM CST</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            {/* Contact Details */}
            <Card>
              <CardHeader>
                <CardTitle className="text-xl flex items-center">
                  <MessageCircle className="w-5 h-5 mr-2 text-primary" />
                  Contact Information
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <div className="font-semibold">Email</div>
                    
                    <div className="text-muted-foreground">hellocarekonnect@gmail.com</div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-success" />
                  </div>
                  <div>
                    <div className="font-semibold">Office</div>
                    <div className="text-muted-foreground">Minneapolis, MN </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Support Hours */}
            <Card className="bg-gradient-to-br from-primary/5 to-accent/5">
              <CardHeader>
                <CardTitle className="text-xl flex items-center">
                  <Clock className="w-5 h-5 mr-2 text-primary" />
                  Support Hours
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-sm">Monday - Friday</span>
                  <span className="text-sm font-medium">8:00 AM - 6:00 PM CST</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm">Saturday</span>
                  <span className="text-sm font-medium">9:00 AM - 2:00 PM CST</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm">Sunday</span>
                  <span className="text-sm font-medium">Emergency Only</span>
                </div>
                <div className="pt-2 border-t border-border/50">
                  <div className="text-xs text-muted-foreground flex items-center gap-2">
                    <Shield className="w-3 h-3" />
                    24/7 emergency support available for Enterprise customers
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
};
export default Contact;